import styled from 'styled-components';

export const VideoThumbnail = styled.div`
  :global(.vjs-progress-control:hover .videoThumbnail) {
    display: inherit;
  }

  :global(.videoThumbnail) {
    display: none;
    position: relative;
  }
`;
